<template>
    <div class="my-3">
        <TextField v-model="system.systemName" @onChange="(value) => system.systemName=value" inputClass="form-input" :title="$t('SystemName')"/>
        <p class="title">{{ $t('Comment') }}</p>
        <input v-model="system.comment" @onChange="(value) => system.comment=value" class="form-input mb-5" style="border-radius: 5px;"/>
        <!--<datalist id="farmsDatalist">
            <option v-for="farm in farms" v-bind:key="farm.id" :value="farm">
                {{ farm }}
            </option>
        </datalist>-->
        <div class="row d-flex justify-content-between pb-5">
            <div class="col flex-grow pr-1">
                <Button title="Cancel" buttonClass='cancel-button semi-bold w-100' @onClick="cancel"/>
            </div>
            <div class="col flex-grow pl-1">
                <Button :title="buttonTitle" buttonClass='save-button semi-bold w-100' @onClick="save"/>
            </div>
        </div>
    </div>
</template>

<script>
    import TextField from '@/components/TextField'
    import Button from '@/components/Button'
    import { getAllFarmsNames, getSystemFarmById, addSystem, updateSystem } from '@api'

export default {
    props: ['id'],
    watch: {},
    methods: {
        getData: async function() {
            //var farms = await getAllFarmsNames();
            //console.log(farms)
            //this.farms = farms;
            if(!this.addMode) {
                this.system = await getSystemFarmById(this.id);
                // this.selectedFarm = this.farms.find(m => m.id === this.system.farmId);
            } else {
                this.system = {}
            }
        },
        cancel() {
            this.$emit('cancel');
        },
        async save() {
            this.system.name = this.system.systemName;
            if(!this.addMode) {
                await updateSystem(this.system);
            } else {
                this.system.farmId = this.farmId
                await addSystem(this.system)
            }
            this.$emit('save');
        }
    },
    computed: {
        farmId() {
            return this.selectedFarm == null ? null : this.selectedFarm.id
        },
        buttonTitle() {
            return this.addMode ? "Add" : "Save"
        },
        addMode() {
            return this.id == null
        }
    },
    components: {
        Button,
        TextField,
    },
    mounted: function () {
        this.getData();
    },
    data: function() {
        return {
            system: {},
            //farms: [],
            selectedFarm: null
        }
    }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Systems/SystemEdit.vue